"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const frontend_1 = require("./frontend");
// Example usage (to be removed/commented for production):
new frontend_1.PreciosOmieFrontend(window.preciosOmie.ajax_url);
